import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink py-12" data-id="element-74" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-75" data-mp="3gezc50oadkzk">
        <p className="font-display text-lg tracking-[0.18em] text-ivory" data-id="element-76" data-mp="3ggk7gsifd7yh">
          YOGA TEACHING <span className="text-gold" data-id="element-77" data-mp="32pffmclatjyp">VAULT™</span>
        </p>
        <p className="mt-4 font-display text-base tracking-[0.22em] text-ivory/50" data-id="element-78" data-mp="36oy1baky1z2l">
          OPEN · CHOOSE · TEACH
        </p>
        <div className="mx-auto mt-7 h-px w-16 bg-gold/50" aria-hidden="true" data-id="element-79" data-mp="3ugbsveb9tqmi" />
        <p className="mt-7 font-sans text-xs leading-relaxed text-ivory/55" data-id="element-80" data-mp="38zbay6h7b62">
          © 2026 Yoga Teaching Vault™ — All rights reserved.
        </p>
        <p className="mx-auto mt-2 max-w-xl font-sans text-[11px] leading-relaxed text-ivory/40" data-id="element-81" data-mp="3lggaopjasvcz">
          Yoga Teaching Vault™ is an educational teaching resource. It does not
          replace professional yoga teacher training, qualifications or
          individualized medical advice.
        </p>
      </div>
    </footer>;
}